let turnstileHasRendered = false;
document.getElementById("leadForm1").addEventListener("shown.bs.modal", function() {
    const container = document.getElementById("cf-turnstileContainer");
    // Only render Turnstile if it hasn't already been rendered
    if (!turnstileHasRendered && window.turnstile && container) {
        turnstile.render("#cf-turnstileContainer", {
            sitekey: "0x4AAAAAAAYDjhZNjYSI8Zc8",
            // sitekey: "3x00000000000000000000FF", // Replace with your real sitekey
            callback: function(token) {
                console.log(`Challenge Success ${token}`);
                // If token field exists, update it; otherwise create one
                let hiddenField = document.querySelector('input[name="cf-turnstile-response"]');
                if (!hiddenField) {
                    hiddenField = document.createElement("input");
                    hiddenField.type = "hidden";
                    hiddenField.name = "cf-turnstile-response";
                    document.getElementById("leadForm").appendChild(hiddenField);
                }
                hiddenField.value = token;
            }
        });
        turnstileHasRendered = true;
    }
});
document.getElementById("leadForm").addEventListener("submit", function(e) {
    document.getElementById("feedbackMessage").classList.add("d-none");
    const tokenInput = document.querySelector('input[name="cf-turnstile-response"]');
    if (!tokenInput || !tokenInput.value) {
        e.preventDefault();
        document.getElementById("feedbackMessage").classList.remove("d-none");
    }
});

//# sourceMappingURL=repo.54fe9462.js.map
